module.exports = __webpack_public_path__ + "static/img/wzry-coreTechnology3.052b318c.png";